'use strict';

import { Alert } from '@material-ui/lab';
import React, { Component } from 'react';
import PopUp from '../../commonModules/interface/PopUp';

var $ = require('jquery');

class ValidationOverlay extends Component{
    state = {      
        popupState: this.props.popupStateButton, 
        msg: this.props.msg,errormsg:""
    }
    componentWillReceiveProps(nextProps) {
        // You don't have to do this check first, but it can help prevent an unneeded render
        if (nextProps.popupStateButton !== this.state.popupState) {
            this.setState({popupState: nextProps.popupStateButton});
        }
    }
    cancel = async (e) => {
        e.preventDefault();
        console.log("Cancel Validation");
        // this.setState({popupState: "overlay hidden",errormsg:""});
        this.props.onCancelation();
    }
    // formatError transforme une réponse d'erreur (succès JSON avec error != 'OK'
    // OU échec HTTP jqXHR) en message lisible. Sans ça, on affichait
    // 'Error : ' + result.error → "Error : undefined" / "Error : [object Object]".
    formatError = (payload) => {
        var status = (payload && payload.status) || 0;
        // Extrait le texte le plus parlant selon la forme de la réponse.
        var raw = null;
        if (payload) {
            raw = payload.responseJSON || payload.error || payload.content
                || payload.responseText || payload.message || payload;
        }
        var text = '';
        if (raw && typeof raw === 'object') {
            text = raw.content || raw.error || raw.message || '';
        } else if (typeof raw === 'string') {
            text = raw;
        }
        var lowered = ('' + text).toLowerCase();
        // Refus d'autorisation (RBAC) : le rôle n'a pas la page requise.
        if (status === 401 || status === 403 || status === 404
            || lowered.indexOf('no access') !== -1
            || lowered.indexOf('not authorized') !== -1
            || lowered.indexOf('autoris') !== -1) {
            return "Accès non autorisé : votre rôle ne permet pas cette action.";
        }
        if (text && typeof text === 'string') {
            return 'Erreur : ' + text;
        }
        return "Une erreur est survenue lors de l'opération.";
    }
    valid = async (e) => {
        e.preventDefault();
        var urlValidation = this.props.url

        this.serverRequest = $.get(urlValidation)
            .done(function(result) {
                console.log('[INFO],  reception front of Validation: ');
                console.log(result);
                if (result && result.error === 'OK') {
                    // this.setState({popupState: "overlay hidden"});
                    if ( this.props.fetchAlerts ) {
                        this.props.fetchAlerts();
                    }
                    this.props.onValidation();
                } else {
                    // Réponse 200 mais error != 'OK' (le BFF a encapsulé le refus).
                    this.setState({ errormsg: this.formatError(result) });
                }
            }.bind(this))
            .fail(function(jqXHR) {
                // Échec HTTP (404 "No Access", 401, etc.) : jQuery ne déclenche
                // pas le succès — sans ce .fail() le refus RBAC ne s'affichait pas.
                console.log('[ERROR], Validation, HTTP', jqXHR && jqXHR.status);
                this.setState({ errormsg: this.formatError(jqXHR) });
            }.bind(this));
    }

    componentWillUnmount() {
        try {
            this.serverRequest.abort();
        } catch (e) {
            console.log(e);
        }
    }
    render() {
        console.log("[DEBUG], Menu,Validation, Button Proceed");
        return (
            // <div className={this.state.popupState}>
            //     <div className="popup">
            <PopUp
                close={this.cancel}
                submitAction={this.valid}
                title={this.props.title || "Confirmation"}
            >
                    <p>{this.props.msg}</p>
                    {this.state.errormsg &&
                        <Alert severity="error">{this.state.errormsg}</Alert>
                    }
                    {/* <div className="text-right">
                        <button className="btn btn-cancel" onClick={this.cancel}>Cancel</button>
                        <button className="btn btn-primary" onClick={this.valid}>Ok</button>
                    </div> */}

            </PopUp>
            //     </div>
            // </div>
        );
    }
}
export default ValidationOverlay
